import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "react-router-dom";
import { IMG_URL } from "../../api/imgApi/ImgApi";

type Props = {
  item: any;
  setIsModalImages: (value: boolean) => void;
  setProductId: (value: string) => void;
};
const Product: FC<Props> = ({ setIsModalImages, item, setProductId }) => {
  const lang: any = localStorage.getItem("i18nextLng");

  const { t } = useTranslation();

  const openImagesModal = (id: any) => {
    setIsModalImages(true);
    setProductId(id);
  };

  return (
    <div className="my_product">
      <div className="product_img_box">
        <LazyLoadImage
          alt="product"
          effect="blur"
          src={
            IMG_URL +
            item.image.map((i: any) =>
              i.isMain ? i.url : item.image[0].url
            )[0]
          }
          className="my_img"
          onClick={() => openImagesModal(item._id)}
        />
      </div>
      <Link to={`/category/product/${item._id}`}>
        <div className="product_info">
          <div className="product_title">
            <p>{item.name?.[lang]}</p>
          </div>
          <div className="product_info_box">
            <div className="product_cost">
              {item.price && item.price + t("FETCHONEPRODUCT.SUM")}
            </div>
            <div className="product_maked">
              <div className="maked_box">
                <p className="maked_name">{item.info[0]?.material?.[lang]}</p>
                <p className="maked_present">
                  {item.info[0]?.amount ? item.info[0]?.amount + "%" : ""}
                </p>
              </div>
              <div className="maked_box">
                <p className="maked_name">{item.info[1]?.material?.[lang]}</p>
                <p className="maked_present">
                  {item.info[1]?.amount ? item.info[1]?.amount + "%" : ""}
                </p>
              </div>
              <div className="maked_box">
                <p className="maked_name">{item.info[2]?.material?.[lang]}</p>
                <p className="maked_present">
                  {item.info[2]?.amount ? item.info[2]?.amount + "%" : ""}
                </p>
              </div>
              <div className="maked_box">
                <p className="maked_name">{item.info[3]?.material?.[lang]}</p>
                <p className="maked_present">
                  {item.info[3]?.amount ? item.info[3]?.amount + "%" : ""}
                </p>
              </div>
              <div className="maked_box">
                <p className="maked_name">{item.info[4]?.material?.[lang]}</p>
                <p className="maked_present">
                  {item.info[4]?.amount ? item.info[4]?.amount + "%" : ""}
                </p>
              </div>
            </div>
          </div>
        </div>
      </Link>
    </div>
  );
};

export default Product;
